import { BaseEntity } from "yt-ng-framework";

export class EOtpremnicaStavka extends BaseEntity{
    constructor(){
        super();
    }   
    EOtpremnicaID: number = null;
    RobaID: number = null;
    Kolicina: number = null;
    // JedinicaMereID: number = null;
    RedniBroj:number=null;
    Sifra:number=null;
    JedinicaMere: string=null;
    JedinicaMereNaziv: string=null;
    BrojSaNarudzbenice: string=null;
    Naziv:string=null;
    Opis:string=null;
    GTIN:string=null;
    AkciznaRoba:string=null;
    AkciznaRobaTipPakovanjaID:number=null;
    AkciznaRobaTipPakovanja:string=null;
    AkciznaRobaTipPakovanjaVrednost:number=null;
    AkciznaRobaSifraRobneMarke:string=null;
    BrojDodatnihAtributa: number = null;

    Deserialize(input:any){  
        super.Deserialize(input);
        this.ID=input.ID;
        this.EOtpremnicaID=input.EOtpremnicaID;
        this.RobaID=input.RobaID;
        this.Kolicina=input.Kolicina;
        // this.JedinicaMereID=input.JedinicaMereID;
        this.RedniBroj=input.RedniBroj;
        this.Sifra=input.Sifra;
        this.JedinicaMere=input.JedinicaMere;
        this.BrojSaNarudzbenice=input.BrojSaNarudzbenice;
        this.Naziv=input.Naziv;
        this.Opis=input.Opis;
        this.GTIN=input.GTIN;
        this.AkciznaRoba=input.AkciznaRoba;
        this.AkciznaRobaTipPakovanjaID=input.AkciznaRobaTipPakovanjaID;
        this.AkciznaRobaTipPakovanja=input.AkciznaRobaTipPakovanja;
        this.AkciznaRobaTipPakovanjaVrednost=input.AkciznaRobaTipPakovanjaVrednost;
        this.AkciznaRobaSifraRobneMarke=input.AkciznaRobaSifraRobneMarke;
        this.BrojDodatnihAtributa=input.BrojDodatnihAtributa;
        return this;
    }

    Serialize(input:EOtpremnicaStavka){
        return input;
    }
}